import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS, UPDATE_DATA_OBJECT } from '@inpart-io/devtools-vue';
import { alliancesManager, DataType, type IAlliance, type IAllianceDetail } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { ALLIANCE_DETAIL_MODULE } from '../alliance-detail-module';

export const CREATE_ALLIANCE = 'createAlliance';
export const ADD_LEADS_TO_ALLIANCE = 'addLeadsToAlliance';
export const REMOVE_LEADS_FROM_ALLIANCE = 'removeLeadsFromAlliance';

export const actions: ActionTree<IAlliance, unknown> = {
    async [CREATE_ALLIANCE](context, { alliance, properties }: { alliance: IAlliance; properties?: string }): Promise<number> {
        const params = {
            properties
        };
        const newAlliance = await alliancesManager.createAlliance(alliance, params);
        await context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [newAlliance] });
        return newAlliance.dobjId;
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IAlliance[] }) {
        const alliances: IAlliance[] = [];
        const details: IAllianceDetail[] = [];

        dataObjectList.forEach((alliance) => {
            const _alliance = Object.assign({}, alliance);

            // Extract Details objects if necessary
            if ((alliance['@detail']?.length ?? 0) > 0) {
                alliance['@detail'].forEach((detail) => {
                    if (detail instanceof Object) {
                        details.push(Object.assign({}, detail, { '@type': DataType.AllianceDetail }));
                        _alliance.detail = detail.dobjId;
                    } else {
                        _alliance.detail = detail;
                    }
                });
            }
            _alliance['@detail'] = undefined;
            alliances.push(_alliance);
        });

        if (alliances.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: alliances });
        }
        if (details.length > 0) {
            void context.dispatch(`${ALLIANCE_DETAIL_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: details }, { root: true });
        }
    },
    async [ADD_LEADS_TO_ALLIANCE](
        context,
        { leadIdList, allianceId, properties }: { leadIdList: number[]; allianceId: number; properties?: string }
    ): Promise<number[]> {
        const alliancesToUpdate = {
            dobjId: allianceId,
            leads: { '@value': leadIdList, '@operation': 'ADD' }
        };
        return context.dispatch(UPDATE_DATA_OBJECT, { dataObjectList: [alliancesToUpdate], properties });
    },
    async [REMOVE_LEADS_FROM_ALLIANCE](
        context,
        { leadIdList, allianceId, properties }: { leadIdList: number[]; allianceId: number; properties?: string }
    ): Promise<number[]> {
        const alliancesToUpdate = {
            dobjId: allianceId,
            leads: { '@value': leadIdList, '@operation': 'REMOVE' }
        };
        return context.dispatch(UPDATE_DATA_OBJECT, { dataObjectList: [alliancesToUpdate], properties });
    }
};
